// @flow
import eshopOrderClick                   from 'fg-frontend/webActions/eshopOrderClick';
import eshopComparisonShowDifferentLines from 'fg-frontend/webActions/eshopComparisonShowDifferentLines';
import eshopUserToolsRefresh             from './webActions/eshopUserToolsRefresh';
import skipToNewItem                     from './webActions/skipToNewItem';

export default (action) => {
  switch (action) {
    case 'eshopUserToolsRefresh':
      return eshopUserToolsRefresh;
    case 'eshopOrderClick':
      return eshopOrderClick;
    case 'eshopComparisonShowDifferentLines':
      return eshopComparisonShowDifferentLines;
    case 'skipToNewItem':
      return skipToNewItem;
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureEshopActions.js